import { useState } from 'react';
import type { AuthUser } from '../types/api';
import { ArrowLeftIcon, LogoutIcon, PackageIcon, UserIcon } from './Icons';
import './Header.css';

interface Props {
  user?: AuthUser | null;
  logoSrc?: string;
  onLogout?: () => void;
  onOrders?: () => void;
  onBackToCatalog?: () => void;
  showBack?: boolean;
}

export default function Header({ user, logoSrc, onLogout, onOrders, onBackToCatalog, showBack }: Props) {
  const [logoError, setLogoError] = useState(false);
  const showLogoImage = Boolean(logoSrc && !logoError);

  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-brand">
          {showBack && (
            <button className="header-back" onClick={onBackToCatalog} aria-label="Voltar" type="button">
              <ArrowLeftIcon size={20} />
            </button>
          )}
          <div className={`header-brand-panel${showLogoImage ? ' header-brand-panel--image' : ''}`}>
            <div className={`header-logo${showLogoImage ? ' header-logo--image' : ''}`}>
              {showLogoImage ? <img src={logoSrc} alt="Villamix Express" onError={() => setLogoError(true)} /> : <span>VM</span>}
            </div>
            {showLogoImage ? (
              <div className="header-text header-text--meta">
                <strong>Supermercado</strong>
                <span>Compra com agilidade</span>
              </div>
            ) : null}
          </div>
          {!showLogoImage && (
            <div className="header-text">
              <strong>Villamix</strong>
              <span>Express Mercado</span>
            </div>
          )}
        </div>

        <div className="header-actions">
          {user ? (
            <>
              <span className="header-user-chip">
                <UserIcon size={16} />
                <span className="header-user-name">{user.name}</span>
              </span>
              {onOrders && (
                <button className="header-btn" onClick={onOrders} title="Meus pedidos" type="button">
                  <PackageIcon size={18} />
                  <span>Pedidos</span>
                </button>
              )}
              <button className="header-btn header-btn--logout" onClick={onLogout} title="Sair" type="button">
                <LogoutIcon size={18} />
                <span>Sair</span>
              </button>
            </>
          ) : null}
        </div>
      </div>
    </header>
  );
}
